/**
 * menu-drawer.js
 * ---------------------------------------------------------------------------------------------------------
 * Behaviour for the full-screen mobile menu drawer. Two concerns:
 *
 *   1. Accordions  — inline expand/collapse inside sub-panels
 *   2. Swipe lock  — blocks Snow's horizontal swipe-to-close
 *
 * Extracted from an inline <script> in main-menu-drawer.liquid; the behaviour is unchanged.
 *
 * Moving the drawer to <body> is NOT done here. DialogElement.shouldAppendToBody reads an append-to-body
 * attribute, so that is set in the markup instead — no prototype patching, and it stays visible to anyone
 * reading the snippet.
 * ---------------------------------------------------------------------------------------------------------
 */
(() => {
  if (window.__ossahMenuDrawer) return;
  window.__ossahMenuDrawer = true;

  /* ── 1. Accordions ─────────────────────────────────────────────────────────────────────────────────── */

  /**
   * Delegated on document rather than on the drawer, because the drawer element is relocated between body
   * and the header on every open and close — a listener bound to it would survive, but binding to the
   * document removes the question entirely, and it is also how this worked before.
   */
  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-drawer-accordion]');
    if (!button) return;

    const content = document.getElementById(button.getAttribute('aria-controls'));
    if (!content) return;

    const isOpen = button.getAttribute('aria-expanded') === 'true';

    if (isOpen) {
      content.removeAttribute('data-open');
      button.setAttribute('aria-expanded', 'false');
    } else {
      content.setAttribute('data-open', '');
      button.setAttribute('aria-expanded', 'true');
    }
  });

  /* ── 2. Swipe lock ─────────────────────────────────────────────────────────────────────────────────── */

  /**
   * DialogElement's GestureArea listens for horizontal touch movement to offer swipe-to-close. Inside a
   * full-screen menu that reads as the panel being dragged off the edge by accident, so horizontal intent is
   * cancelled and vertical scrolling is left alone.
   *
   * Bound on document with capture so it runs before the gesture handler regardless of when either was
   * registered, and non-passive because it calls preventDefault. Both are required: a passive listener
   * cannot cancel the gesture, and Chrome treats touchmove on document as passive by default.
   */
  let startX = 0;
  let startY = 0;
  let locked = false;

  const inDrawer = (target) => target instanceof Element && target.closest('#menu-drawer');

  document.addEventListener('touchstart', (event) => {
    if (!inDrawer(event.target)) return;
    const touch = event.touches[0];
    startX = touch.clientX;
    startY = touch.clientY;
    locked = false;
  }, { passive: true, capture: true });

  document.addEventListener('touchmove', (event) => {
    if (locked || !inDrawer(event.target)) return;

    const touch = event.touches[0];
    const dx = Math.abs(touch.clientX - startX);
    const dy = Math.abs(touch.clientY - startY);

    if (dx > dy && dx > 5) {
      event.preventDefault();
      event.stopPropagation();
      locked = true;
    }
  }, { passive: false, capture: true });
})();